import { createSelector } from 'reselect';

import { AppState } from '../../../../store/store';
import { BonusSettlementsState } from './bonus-settlements-detail-reducer';

const bonusSettlementDetailState = (state: AppState): BonusSettlementsState => {
    return state.bonusSettlements.detail;
};

export const bonusSettlementDetailSelector = createSelector(bonusSettlementDetailState, state => ({
    bonusSettlementDetails: state.bonusSettlementDetails,
}));

export const poolBonusSettlementDetailSelector = createSelector(bonusSettlementDetailState, state => ({
    poolBonusSettlementDetails: state.poolBonusSettlementDetails,
}));

export const bonusSettlementSuppliersSelector = createSelector(bonusSettlementDetailState, state => ({
    bonusSettlementSuppliers: state.bonusSettlementSuppliers,
}));

export const poolBonusSettlementSuppliersSelector = createSelector(bonusSettlementDetailState, state => ({
    poolBonusSettlementSuppliers: state.poolBonusSettlementSuppliers,
}));
